export default {
  ON_FIELD_CHANGE: 'ON_CHANGE',
  ON_RULE_CHANGE: 'ON_RULE_CHANGE',
  ON_KEY_PRESS: 'ON_KEY_PRESS',
  VALIDATION_IN_PROGRESS: 'VALIDATION_IN_PROGRESS',
  VALIDATION_SUCCESS: 'VALIDATION_SUCCESS',
  VALIDATE_FIELD: 'VALIDATE_FIELD',
  ADD_CONTEXT: 'ADD_CONTEXT',
  REMOVE_CONTEXT: 'REMOVE_CONTEXT',
  NOTIFY_NOT_READY: 'NOTIFY_NOT_READY',
  ON_FORM_INIT: 'ON_FORM_INIT',
  ON_FIELD_BLUR: 'ON_FIELD_BLUR',
  ON_FORM_FILL: 'ON_FORM_FILL',
  FORM_IN_COMPLETE: 'FORM_IN_COMPLETE'
};